/**
 * React Aria's `FocusScope contain` (used by our `DrawerNew`/`Modal`) would keep
 * pulling focus out of the Featurebase feedback widget iframe whenever it's
 * opened on top of an already-open drawer. Tagging the iframe with
 * `data-react-aria-top-layer` tells `FocusScope` / `ariaHideOutside` to treat
 * it as a sibling top-layer surface and leave focus alone.
 */
export const markFeaturebaseIframesAsTopLayer = () => {
  document
    .querySelectorAll('iframe[src*="featurebase.app"]')
    .forEach((iframe) => iframe.setAttribute("data-react-aria-top-layer", "true"));
};

export const openFeaturebaseFeedbackWidget = () => {
  window.postMessage({
    target: "FeaturebaseWidget",
    data: {
      action: "openFeedbackWidget",
    },
  });
};
